<template>
<div class="timer">
    <svg id="svg" width="110" height="110" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <circle id="red" r="45" cx="55" cy="55" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0"></circle>
        <circle id="bar" :r="r" cx="55" cy="55" fill="transparent" stroke-dasharray="565.48" :stroke-dashoffset="pct"></circle>
    </svg>
    <p class="counter">{{maxTime}} <span>mp</span></p>
</div>
</template>

<script>


export default {
    props: [
        'timeLimit'
    ],
    data: () => {
      return {
        r: 45,
        pct: 0,
        maxTime: 0,
        myInterval: '',
      }
    },
    mounted() {
        var vm = this;  
        vm.maxTime=this.timeLimit;
        vm.$store.state.timer = false;
        vm.myInterval = setInterval(function() {
            vm.maxTime--;
                
            var c = Math.PI*(vm.r*2)
            vm.pct = -(((vm.timeLimit-vm.maxTime)/vm.timeLimit)*c);
            if(vm.maxTime <= 0) {
                vm.$store.state.timer = true;
                clearInterval(vm.myInterval);
            }
        }
    , 1000)
    },
    beforeDestroy() {
        clearInterval(this.myInterval);
    }

};


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '~@/assets/sass/base/variables';
    .timer {
        width: 110px;
        height: 110px;
        position: absolute;
        right: 34.5px;
        top: 66px;

        #svg {
            transform: rotate(-90deg);
            #bar{
                stroke: $timer-color-2;
                stroke-width: 10px
            }

            #red {
                stroke: $timer-color-1;
                stroke-width: 9px;
            }
        
        }

        .counter {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate3d(-50%, -50%, 0);
            font-size: 38px;
            color: $font-color-1;
            margin: 0;

            span {
                font-size: 15px;
                display:block;
            }
        }
    }

</style>
